import React, { FC, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useTranslation } from 'react-i18next';
import { TDealerContactsProps } from '../../types/dealerLocatorDetail.types';
import DealerLocatorAttribute from './dealerContactAttribute';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import { googleStaticMapUrl, gooleMapUrl, maxZoomSize, staticMapInitialZoom } from '../../../../constants/map.constatnts';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import dealerPinSvg from '../../../../assets/pin-dealer-detail.svg';
import './styles.scss';

const DealerLocatorContacts: FC<TDealerContactsProps> = ({ addressDetails, apiKey, latitude, longitude }) => {
  const { t } = useTranslation();
  const [zoom, setZoom] = useState(staticMapInitialZoom);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const size = isDesktop ? 392 : 343;
  return (
    <section className="dealer-locator-detail__contacts">
      <div className="dealer-locator-detail__contacts--wrapper">
        <div className="dealer-locator-detail__contacts__details">
          <Text
            field={{ value: t('cnhi-dealerLocatorDealerContacts') }}
            tag="div"
            editable={false}
            className={'dealer-locator-detail__contacts__title'}
          />
          {addressDetails?.address && (
            <Text
              field={{ value: addressDetails?.address }}
              tag="div"
              editable={false}
              className={'dealer-locator-detail__contacts__address'}
            />
          )}
          <RoutableNotEditableLink
            target={'_blank'}
            href={`${gooleMapUrl}${latitude},${longitude}`}
            className={'dealer-locator-detail__contacts__directions'}
          >
            <Text field={{ value: t('cnhi-dealerLocatorGetDirections') }} tag="div" editable={false} />
            <Icon iconName="geolocation-distance-full" color={'primary'} size={iconSize['mbl']} />
          </RoutableNotEditableLink>
          <section className={'dealer-locator-detail__contacts__attributes--wrapper'}>
            {addressDetails?.fax && (
              <DealerLocatorAttribute href={`fax:${addressDetails?.fax}`} iconName={'file-print'} attribute={addressDetails?.fax} />
            )}
            {addressDetails?.phone && (
              <DealerLocatorAttribute
                href={`tel:${addressDetails?.phone}`}
                iconName={'phone-messages-phone'}
                attribute={addressDetails?.phone}
              />
            )}
            {addressDetails?.email && (
              <DealerLocatorAttribute
                href={`mailto:${addressDetails?.email}`}
                iconName={'social-sharing-email'}
                attribute={addressDetails?.email}
              />
            )}
            {addressDetails?.website && (
              <DealerLocatorAttribute
                href={addressDetails?.website}
                iconName={'social-sharing-globe'}
                attribute={addressDetails?.website}
                openInNewTab={true}
              />
            )}
          </section>
        </div>
        <div className="dealer-locator-detail__contacts__map">
          <img src={`${googleStaticMapUrl}?center=${latitude},${longitude}&zoom=${zoom}&size=${size}x${size}&key=${apiKey}`} alt="" />
          <RoutableNotEditableLink
            target={'_blank'}
            href={`${gooleMapUrl}${latitude},${longitude}`}
            className="dealer-locator-detail__map-icon dealer-locator-detail__map-icon--get-location"
          >
            <img src={dealerPinSvg} alt="" />
          </RoutableNotEditableLink>
          <div
            className="dealer-locator-detail__map-icon dealer-locator-detail__map-icon--zoom-in"
            onClick={() => zoom < maxZoomSize && setZoom(zoom + 1)}
          >
            <Icon color={'white'} iconName="action-plus" size={iconSize['dsk']} />
          </div>
          <div
            className="dealer-locator-detail__map-icon dealer-locator-detail__map-icon--zoom-out"
            onClick={() => zoom > 1 && setZoom(zoom - 1)}
          >
            <Icon color="white" iconName="action-minus" size={iconSize['dsk']} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DealerLocatorContacts;
